import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25cfb5ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding-bottom":"80px"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("返 回")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("提 交")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_VEselect = _resolveComponent("VEselect")!
  const _component_Wangeditor = _resolveComponent("Wangeditor")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_PageMain = _resolveComponent("PageMain")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_FixedActionBar = _resolveComponent("FixedActionBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageMain, {
      title: '操作手册-' + _ctx.pageTitle[_ctx.type]
    }, {
      default: _withCtx(() => [
        (_ctx.addOrEditFormShow)
          ? (_openBlock(), _createBlock(_component_el_form, {
              key: 0,
              class: "addForm disabledFormShow",
              model: _ctx.addOrEditForm,
              rules: _ctx.addOrEditRules,
              ref: "addOrEditFormRef",
              "label-width": "auto",
              disabled: _ctx.formDisabled,
              "label-position": "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "手册名称：",
                  prop: "name",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.addOrEditForm.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.addOrEditForm.name) = $event)),
                      placeholder: "请输入手册名称",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "所属菜单：",
                  prop: "parent_id"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.addOrEditForm.parent_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.addOrEditForm.parent_id) = $event)),
                      placeholder: "请选择所属菜单",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "迭代版本：",
                  prop: "iteration_id"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_VEselect, {
                      selectValue: _ctx.addOrEditForm.iteration_id,
                      "onUpdate:selectValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addOrEditForm.iteration_id) = $event)),
                      apiUrl: ['iteration', 'getList'],
                      placeholder: "请选择迭代版本",
                      queryData: {
              project_id: _ctx.projectId,
            },
                      queryName: "name",
                      objLabel: "name",
                      objKey: "id",
                      selectedObj: _ctx.addOrEditForm.terationSelectedObj
                    }, null, 8, ["selectValue", "queryData", "selectedObj"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "内容：",
                  prop: "content",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Wangeditor, {
                      wangeditorId: "wangeditorId",
                      ref: "wangeditorRef",
                      onInit: _ctx.ditorInit
                    }, null, 8, ["onInit"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules", "disabled"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_FixedActionBar, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: _ctx.onReturn
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]),
        (_ctx.type !== 2)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              loading: _ctx.determineBtnLoading,
              type: "primary",
              onClick: _ctx.onSubmit
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["loading", "onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}